export default {
  home: "Startseite",
  aboutUs: "Über uns",
  capabilities: "Fähigkeiten",
  esg: "Nachhaltigkeit",
  careers: "Karriere",
  contact: "Kontakt",
  ourJourney: "Unsere Reise",
  visionMission: "Vision & Mission",
  leadershipTeam: "Führungsteam",
};

